import includes from 'lodash/includes';
import { parseUserAgent, detectOS } from 'detect-browser';
import { isGooglebot } from './googlebot';
import { isFacebookApp } from './facebook';

const supportedBrowsers = [
  'android',
  'chrome',
  'edge',
  'firefox',
  'ie',
  'ios',
  'safari'
];

export const browserName = ua => {
  if (isGooglebot(ua)) {
    return 'googlebot';
  }

  if (isFacebookApp(ua)) {
    return 'facebook-app';
  }

  const browser = parseUserAgent(ua);
  if (browser && includes(supportedBrowsers, browser.name)) {
    return browser.name;
  }
  const browserOs = detectOS(navigator.userAgent);
  return browserOs ? browserOs : 'other';
};
